<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <div style="text-align:center; font-size: 16px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
        {{ $t('homeMobileManagement.logoDescription') }}
      </div>
      <div style="text-align:center; text-align:left;color:#5b6c7f;">
        {{ $t('homeMobileManagement.logoSizeRecommend') }}
      </div>
    </div>
    <form class="form-horizontal">
      <div class="box-body">
        <div class="form-group required">
            <div class="col-sm-6">
                <!-- 768×227 -->
                <img
                    id="logo-img-id"
                    :src="logoImage !== null && logoImage !== '' ? logoImage : img_url.img_other_no_picture_available"
                    :style="`background-image: url(${img_url.backgroundPattern}); background-size: 15pt;`"
                    class="logo-img-class"
                    alt="mobile-home-logo-img">
                <div style="padding-top: 6px;">
                    <input
                        id="upload-logo-img"
                        type="file"
                        accept="image/*"
                        @change="onSelectLogoImg">
                    <p>{{ $t('banner.clickImageToAddOrUpdate') }}</p>
                    <span
                        v-if="logoImage !== null && logoImage !== ''"
                        class="remove-logo-img"
                        @click="onClickRemoveLogoImg">{{ $t('common.delete') }}</span>
                </div>
            </div>
        </div>
      </div>
      <div class="box-footer">
        <button
          type="button"
          class="btn btn-labeled btn-success pull-right"
          style="margin-right: 5px;"
          @click="onUpdateLogoImage"
        >
          <span class="btn-label">
            <i class="glyphicon glyphicon-ok"></i>
          </span>
          {{ $t("common.save") }}
        </button>
      </div>
    </form>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#1E90FF"
    ></loading>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import configuration from "../../lib/config";
import { uploadFileToMediaAgent } from '@/lib/utils'

export default {
  name: "HomeMobileLogo",
  data() {
    return {
      img_url: configuration.imgUrlConfig,
      isLoading: false,
      logoImage: null,
      imageFile: null,
    };
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  watch: {
  },
  created () {
      this.GET_PROJECT_MOBIHOME_LOGO().then(
        function (res) {
          let data = res.data
          this.logoImage = data.logoUrl
        }.bind(this)
      )
  },
  mounted() {
    $(function () {
      $('#logo-img-id').on('click', function () {
        $('#upload-logo-img').click()
      })
    })
  },
  methods: {
    onUpdateLogoImage: async function () {
      let filter = {
        imageUrl: this.logoImage
      }
      if (this.imageFile) {
        this.logoImage = await uploadFileToMediaAgent(this.imageFile, 'project/mobile-logo')
        filter['imageUrl'] = this.logoImage
      }
      this.SET_PROJECT_MOBIHOME_LOGO(filter).then(
        function () {
          this.SUCCESS_TOAST()
        }.bind(this)
      ).catch(
        function () {
          this.ERROR_TOAST()
        }.bind(this)
      )
    },
    onClickRemoveLogoImg: function () {
      let inputForm = $('#upload-logo-img')
      inputForm.val('')
      this.logoImage = null
      this.imageFile = null
    },
    /**
     * Select issuance img
     */
    onSelectLogoImg: function (e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.getResultFile(files[0])
      this.logoImage = URL.createObjectURL(files[0])
    },
    getResultFile: function (file) {
      let vm = this
      vm.imageFile = file
    },
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_PROJECT_MOBIHOME_LOGO",
      "SET_PROJECT_MOBIHOME_LOGO"
    ]),
  },
  components: {
    Loading,
    "lte-core-alert": LTECoreAlert
  }
};
</script>
<style scoped>
.form-group.required .control-label:after {
  color: #d00;
  position: absolute;
  margin-left: 8px;
  margin-top: -3px;
  font-family: "FontAwesome";
  font-weight: normal;
  font-size: 9px;
  content: "\f069";
}
.logo-img-class{
  width: 300pt;
  height: 100pt;
  border-color: darkgray;
  border-style: solid;
  border-width: 0.5pt;
  cursor: pointer;
  object-fit: contain;
}
input[type="file"] {
  display: none;
}
.remove-logo-img{
  color: #EF5350;
  cursor: pointer;
}
.remove-logo-img:hover{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/HomeMobileManagement/HomeMobileLogo.vue